<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark"  @click="back" >
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item  class="el-icon-back">考试培训</el-breadcrumb-item>
            <el-breadcrumb-item>考试统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#fff"
          >
            <el-menu-item index="1">个人排名</el-menu-item>
            <el-menu-item index="2">班组排名</el-menu-item>
          </el-menu>
          <!--  -->
          <div class="build-table">
            <div
              style="display:flex;border-top:10px solid #f5f5f5;width:100%;height:80px;align-items:center;justify-content: space-between;padding:0px 10px"
            >
              <el-input
                v-model="search.name"
                placeholder="请输入姓名"
                clearable
                @input="watchInput"
                style="width:200px;padding:10px"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
              <!-- <el-button type="primary" @click="push">添加设备</el-button> -->
            </div>
            <!-- 表格 -->
            <div style="width:100%;height:calc(100% - 80px)" v-if="activeIndex==2">
              <el-table
                stripe
                :data="listData1"
                height="100%"
                style="width: 100%;"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
              >
                <template slot="empty">
                  <p>{{dataText1}}</p>
                </template>
                <el-table-column label="序号">
                  <template slot-scope="scope">
                    <a>{{ scope.$index+1}}</a>
                  </template>
                </el-table-column>
                <el-table-column label="班组名称">
                  <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="平均得分">
                  <template slot-scope="scope">
                    <span>{{ scope.row.examScore }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="参考人数">
                  <template slot-scope="scope">
                    <span>{{ scope.row.allNum }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="排名" width="100">
                  <template slot-scope="scope">
                    <span>{{ scope.row.rank }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="备注" prop="createDate">
                  <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  -->
            <div style="width:100%;height:calc(100% - 80px)" v-if="activeIndex==1">
              <el-table
                stripe
                :data="listData"
                height="100%"
                style="width: 100%;"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号">
                  <template slot-scope="scope">
                    <a>{{ scope.$index+1}}</a>
                  </template>
                </el-table-column>
                <el-table-column label="姓名">
                  <template slot-scope="scope">
                    <span>{{ scope.row.NAME }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="得分">
                  <template slot-scope="scope">
                    <span>{{ scope.row.examScore }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="排名">
                  <template slot-scope="scope">
                    <span>{{ scope.row.rank }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="是否通过" prop="createDate">
                  <template slot-scope="scope">
                    <span style="color: #f00;"  v-if="scope.row.examScore < score">未通过</span>
                    <span style="color:#85ce61;" v-if="scope.row.examScore >= score">已通过</span>
                  </template>
                </el-table-column>
                <el-table-column label="备注" prop="createDate">
                  <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      search: {},
      activeIndex: '1',
      name: '',
      listData: [],
      listData1:[],
      dataText: '正在加载中',
      dataText1: '正在加载中',
      id: '',
      groupType:'',
      score:''
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.score = this.$route.params.score
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
    if (util.session.get('roleId') == '3') {
      this.groupType = '3'
    } else if (this.$store.state.roleId == '4') {
      this.groupType = '1'
    } else if (this.$store.state.roleId == '5') {
      this.groupType = '2'
    }
    this.getData()
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      this.activeIndex = key
      this.getData()
    },
    getData() {
      var that = this
      console.log(this.activeIndex)
      if(this.activeIndex==1){
         myHttp
        .individualRanking({
          projectId: this.groupId,
          paperId: this.id,
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
              that.listData= resp.data.data.Paper
              if(that.listData.length==0){
                that.dataText='暂无数据'
              }
            } else {
              this.$message.error(resp.msg)
              that.dataText='服务器出错'
            }
          },
          function () {}
        )
      }else{
        // teamRanking
           myHttp.teamRanking({
          projectId: this.groupId,
          paperId: this.id,
          type:this.groupType
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
              that.listData1= resp.data.data.Paper
                if(that.listData1.length==0){
                that.dataText1='暂无数据'
              }
            } else {
              this.$message.error(resp.msg)
                that.dataText1='服务器出错'
            }
          },
          function () {}
        )
      }
     
    },
    watchInput() {},
    back(){
      this.$router.go(-1)
    }
  },
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
  cursor: pointer;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #ecf0f5;
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 60px);
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
</style>